export class Note {
  id: number
  subject: Date
  note: string
  ownerType: string
  ownerId: number
  category: string
}
